// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailA":"A_wave2DetailA__853Il"};